import { render, staticRenderFns } from "./DeleteRelationNote.vue?vue&type=template&id=c4e4fb20"
import script from "./DeleteRelationNote.vue?vue&type=script&lang=js"
export * from "./DeleteRelationNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports